// extracted by mini-css-extract-plugin
module.exports = {"socialCard":"social-card_socialCard__1sJ7x","socialCard__logo":"social-card_socialCard__logo__13paB"};